import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {
    width: "90vw",
  },
  order: {
    width: "100%",
    padding: 0,
  },
  orderContent: {
    padding: 0,
  },
  orderList: {
    width: "100%",
  },
}));

export default styles;
